import FormDialog from 'components/Dialogs/FormDialog';
import { ProformaCapTableForm } from 'components/Forms';
import { ProformaCaptableDialogProps } from './ProformaCaptableDialog.props';

const ProformaCaptableDialog = ({
  open,
  title,
  editMode,
  onClose,
  onSave,
  isValid,
  tableTerms,
  initialValues,
  onFormChange,
}: ProformaCaptableDialogProps) => (
  <FormDialog
    open={open}
    title={title}
    subtitle="Current Cap Table, Fund Ownership, and Breakpoint Analysis will be copied to the new version"
    editMode={editMode}
    onClose={onClose}
    onSave={onSave}
    isValid={isValid}>
    <ProformaCapTableForm tableTerms={tableTerms} initialValues={initialValues.values} onFormChange={onFormChange} />
  </FormDialog>
);

export default ProformaCaptableDialog;
